import React from 'react';
import { Section } from '../ui/Section';
import { AccordionItem } from '../ui/Accordion';
export function FAQ() {
  const faqs = [{
    q: '¿Cuándo recibo el producto?',
    a: 'Inmediatamente después del pago vas a recibir el acceso para descargarlo en tu correo electrónico.'
  }, {
    q: '¿En qué formato viene?',
    a: 'En formato PDF digital, optimizado para que puedas usarlo en tablet, móvil o imprimirlo si preferís el papel.'
  }, {
    q: '¿Necesito experiencia previa haciendo journaling?',
    a: 'No. Está guiado paso a paso para que podás empezar aunque nunca hayas escrito así. Las preguntas te van a llevar de la mano.'
  }, {
    q: '¿Tengo que hacerlo en 60 días exactos?',
    a: 'No. Podés hacer una pregunta por día o avanzar a tu ritmo. Lo importante es la honestidad, no la perfección ni la velocidad.'
  }, {
    q: '¿Reemplaza la terapia?',
    a: 'No. Es una herramienta de autoconocimiento y reflexión profunda. No reemplaza el acompañamiento de un profesional de salud mental, pero es un excelente complemento.'
  }, {
    q: '¿Y si me moviliza mucho?',
    a: 'Está pensado para que podás ir a tu ritmo, parar cuando lo necesités y retomarlo sin culpa. Además, el Kit de Emergencia Emocional (Bono 1) te ayudará en esos momentos.'
  }, {
    q: '¿Tiene garantía?',
    a: 'Sí. Probalo durante 30 días sin riesgo. Si sentís que Viaje a tu Interior no te ayudó a mirar hacia dentro o entenderte mejor, podés pedir la devolución total de tu dinero. Sin preguntas.'
  }];
  return <Section bgColor="cream" data-id="element-71">
      <div className="max-w-3xl mx-auto" data-id="element-72">
        <div className="text-center pt-[10px] pb-[10px] mt-[5px] mb-[5px]" data-id="element-73">
          <h2 className="text-3xl md:text-4xl font-serif mb-4" data-id="element-74">
            Preguntas Frecuentes
          </h2>
          <p className="text-brand-light" data-id="element-75">
            Todo lo que necesitás saber antes de empezar.
          </p>
        </div>

        <div className="bg-white rounded-sm shadow-sm p-6 md:p-10 pt-[0px] pb-[0px]" data-id="element-76">
          {faqs.map((faq, idx) => <AccordionItem key={idx} question={faq.q} answer={faq.a} data-id="element-77" />)}
        </div>
      </div>
    </Section>;
}